export default "__VITE_ASSET__DNs5_gbC__"